var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 84V56a24 24 0 0 1 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3a24 24 0 0 1 21.5 13.3L312 32h112a24 24 0 0 1 24 24v28a12 12 0 0 1-12 12H12A12 12 0 0 1 0 84zm416 56v324a48 48 0 0 1-48 48H80a48 48 0 0 1-48-48V140a12 12 0 0 1 12-12h360a12 12 0 0 1 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"}));
}

Trash.defaultProps = {"aria-hidden":"true","data-icon":"trash-alt","viewBox":"0 0 448 512"};

module.exports = Trash;

Trash.default = Trash;
